import React, { Fragment, FunctionComponent, useContext, useEffect, useState } from 'react';

import { Text } from '../../../shared/Text';
import { StepperContent, StepperHeader, StepperSubmit } from '../../../shared/Stepper';
import { useForm } from 'react-hook-form';
import { Input } from '../../../shared/Input';
import { formItems } from '../formItems';
import { InputHolder, InputHolderItem } from '../../../shared/InputHolder';
import { FormContext } from '../../../../store/surplus/SurPlusContext';
import { currencyToNumber, numberToCurrency, scrollToTop } from '../../../../utils';
import { parseSearchQuery } from '../../../../utils';

export const Step1: FunctionComponent<{ id: number }> = ({id}) => {
	const {
		register,
		handleSubmit,
		formState: {errors, isValid},
	} = useForm({mode: 'onChange', defaultValues: {
		[formItems.housePrice]: numberToCurrency(parseSearchQuery(window.location.search)[`Woning`] as unknown as number, true)}
	});

	const [completedText, setCompletedText] = useState('');
	const { updateForm, consumer } = useContext(FormContext);

	const onSubmit = (data: any) => {
		data[formItems.housePrice] = currencyToNumber(data[formItems.housePrice]);
		updateForm(data);
		setCompletedText(numberToCurrency(parseInt(data[formItems.housePrice]), true));
	};

	useEffect(() => {
		setTimeout(() => {
			scrollToTop(typeof parseSearchQuery(window.location.search)[`Woning`] !== 'undefined');
		}, 500)
		//scrollTo();
	}, [])

	return (
		<Fragment>
			<StepperHeader title="Huidige woning" id={id} completedText={completedText}/>

			<StepperContent>
				<Text as="h2">Wat is de huidige waarde van je woning?*</Text>
				<form onSubmit={handleSubmit(onSubmit)}>
					<InputHolder>
						<InputHolderItem isFullWidth={true}>
							<Input
								label=""
								name={formItems.housePrice}
								id={formItems.housePrice}
								type="currency"
								hasError={errors[formItems.housePrice]}
								placeholder="€"
								register={register}
								validation={{required: true}}
							/>
							{errors[formItems.housePrice] && (
								<span className="form__error">Vul verkoopprijs van je huidige woning in</span>
							)}
							{!consumer.status && (
							<Text as="p">
								Weet je deze niet exact? Geen probleem. Noteer dan de vraagprijs van de woning, maak een schatting of <a href="https://www.hypotheker.nl/zelf-berekenen/wat-is-deze-woning-waard/" target="_blank">bereken je woningwaarde</a>.
							</Text>
							)}
						</InputHolderItem>
					</InputHolder>
					<StepperSubmit id={id} isValidated={isValid}/>
				</form>
			</StepperContent>
		</Fragment>
	);
};
